import apiClient from './apiClient';
import type { Document } from './documentApi';

export interface DocumentAuditLog {
  id?: number;
  document_id: number;
  action: string;
  actor_id: number;
  actor_name?: string;
  actor_role?: string;
  description?: string;
  created_at?: string;
}

export interface ValidationData {
  status?: string;
  validation_status?: string;
  validated_by?: number;
  validated_by_name?: string;
  validation_date?: string;
  validation_notes?: string;
  rejection_reason?: string;
}

const documentValidationApi = {
  validateDocument: (documentId: number, data: ValidationData) => {
    return apiClient.put<Document>(`/archive/documents/${documentId}/validate`, data);
  },

  createAuditLog: (data: Partial<DocumentAuditLog>) => {
    return apiClient.post<DocumentAuditLog>('/archive/document-audit-logs', data);
  },
};

export default documentValidationApi;
